const FEET_PER_METER = 3.28084;
const METERS_PER_MILE = 1609.344;

/**
 * Converts distance from meters to feet, rounded to two decimal places.
 */
export function metersToFeet(meters: number): number {
    return Math.round(meters * FEET_PER_METER * 100) / 100;
}

export function feetToMeters(feet: number): number {
    return Math.round((feet / FEET_PER_METER) * 100) / 100;
}

export function metersToMiles(meters: number): number {
    return Math.round((meters / METERS_PER_MILE) * 100) / 100;
}
